<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader title="Manage Advertisement Sections" />
        <div class="loader">
          <Wave
            v-if="loading || updating || deleting"
            width="50px"
            color="#d9534f"
          />
        </div>
        <div>
          <md-button class="md-primary mx-4" :to="{ name: 'Adverts' }">
            View Adverts
          </md-button>
          <md-button class="md-primary" :to="{ name: 'Create Advert Section' }">
            Add Section
          </md-button>
        </div>
      </div>
      <md-table
        v-model="sections.mdData"
        md-card
        md-sort="title"
        md-sort-order="asc"
      >
        <md-table-toolbar class="mb-4">
          <div class="md-toolbar-section-start"></div>
          <div class="toolbar-filter-wrapper">
            <md-field md-clearable class="md-toolbar-section-end">
              <md-input placeholder="Search by name..." v-model="search" />
            </md-field>
          </div>
        </md-table-toolbar>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="S/N">{{ item.id }}</md-table-cell>
          <md-table-cell md-label="Title">{{ item.title }}</md-table-cell>
          <md-table-cell md-label="Tag">{{ item.tag }}</md-table-cell>
          <md-table-cell md-label="Amount">{{
            item.amount | formatMoney
          }}</md-table-cell>
          <md-table-cell md-label="Status">
            <div
              class="badge"
              :class="{
                success: item.visibility_status == 'live',
                grey: item.visibility_status == 'draft'
              }"
            >
              {{ item.visibility_status }}
            </div></md-table-cell
          >

          <md-table-cell md-label="Actions" md-numeric>
            <div class="table-actions">
              <!-- <md-button
                v-if="item.visibility_status === 'draft'"
                :disabled="updating"
                md-menu-trigger
                class="bgsuccess btn-sm"
                >Publish</md-button
              > -->
              <md-button
                :disabled="updating"
                md-menu-trigger
                :to="{ name: 'Edit Advert Section', params: { id: item.id } }"
                class="bggreen btn-sm"
                >Edit</md-button
              >
              <md-button
                :disabled="updating"
                md-menu-trigger
                class="bggreen btn-icon"
                @click="remove(item.id)"
                ><i class="material-icons">close</i></md-button
              >
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <span v-if="loading" class="b-loading">Loading...</span>
      <pagination
        v-model="sections.mdPage"
        :records="sections.mdCount"
        :per-page="sections.mdPerPage"
        @paginate="updatePagination"
      />
    </md-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("advert");
export default {
  name: "Advert",
  data() {
    return {
      updating: false,
      deleting: false,
      search: "",
      time: null
    };
  },
  watch: {
    search(val) {
      this.waitForIt(val);
    }
  },

  methods: {
    ...mapActions(["getSections", "deleteSection"]),
    async updatePagination(page) {
      let data = { page };
      if (this.search) data.keyword = this.search;
      await this.getSections(data);
    },
    async submitSearch() {
      await this.getSections({ keyword: this.search });
    },

    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    },
    async remove(id) {
      try {
        const conf = confirm("Are you sure?");
        if (conf) {
          this.deleting = true;
          await this.deleteSection(id);
          this.deleting = false;
          this.toast("success", "Portfolio Deleted");
        }
      } catch (err) {
        this.deleting = false;

        this.toast("error", "Opps, something went wrong");
      }
    }
  },
  created() {},
  mounted() {
    this.getSections();
  },
  computed: {
    ...mapGetters(["sections", "loading"])
  }
};
</script>

<style lang="scss" scoped>
.md-table-cell {
  width: 0% !important;
  padding: 0rem 0.8rem;
}

.md-table + .md-table {
  margin-top: 16px;

  thead {
    height: 50px !important;
  }
}

.table-actions {
  width: 100%;
  display: flex;
  justify-content: end;
}
</style>
